import { render, staticRenderFns } from "./CreateGoodsCategory.vue?vue&type=template&id=342891a9&"
import script from "./CreateGoodsCategory.vue?vue&type=script&lang=js&"
export * from "./CreateGoodsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports